export default [
	{
		path: "/pros/profile/edit-faq",
		exact: true,
		component: "EditProfileFAQ/EditProfileFAQ",
		mui: true,
	},
];
